/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import { CSVLink } from "react-csv";
import * as MatStyled from "@mui/material/styles";
// import { makeStyles } from '@material-ui/core'

import { Pagination } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import MuiTextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
// import Pagination from "@mui/material/Pagination";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GradingIcon from "@mui/icons-material/Grading";
// import InputAdornment from "@mui/material/InputAdornment";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RestoreIcon from "@mui/icons-material/Restore";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import PauseIcon from "@mui/icons-material/Pause";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import HistoryIcon from "@mui/icons-material/History";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  getProductListAdmin,
  getProductListSeller,
  deleteProduct,
  requestDeleteProduct,
  holdProduct,
  unHoldProduct,
  requestHoldProduct,
  requestUnHoldProduct,
  clearRequestProduct,
  getProductCsvDataAdmin,
  updateProductPublic,
  updateProductStock,
  approveAllSelectedProduct,
  updateProductStockInfo,
  updateMultipleStock,
  getProductStockCsvData,
  importProductStockCsvData,
} from "src/api/product";

import { Grey, Primary, White } from "src/styles/color";
import { useAuth } from "src/hooks/useAuth";
import { UseUpload } from "src/context/UploadProductContext";
import { useDialog } from "src/context/DialogContext";

import Button from "src/components/core/Button";
import Dropdown from "src/components/core/Dropdown";
import { IOSSwitch } from "src/components/core/Switch";
import TextField from "src/components/core/TextField";
import CollapsibleTable from "src/components/core/CollapsibleTable";

import ApproveProduct from "src/modules/product/ProductPreview";
import ProductMenuBar from "src/components/product/ProductMenuBar";
import { IconButton } from "material-ui";
import { Colors } from "src/common/color";
import { convertIntToCurrency } from "src/common";
import UploadFile from "src/components/upload/dropzone/UploadFile";

// const WrapperPagination = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   margin: 20px 5px;
//   display: flex;
//   .MuiPaginationItem-root.Mui-selected {
//     background-color: #e04132;
//     color: #ffffff;
//     :hover {
//       background-color: #e04132;
//       color: #ffffff;
//       opacity: 0.9;
//     }
//   }
// `;

const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
// const ImageNotFound = styled.image`
// 	width: 120px;
// 	height: 120px;
// 	background-image: url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg');
// 	background-repeat: no-repeat;
// 	background-size: 100%;
// `;
const ImgDisplay = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
  flex-shrink: 0;
`;
const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin-left: auto;

  .Button-Add {
    color: #ffffff;
    width: 100%;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function ProductList({ open }) {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog } = useDialog();

  const {
    onCopyProduct,
    masterdata,
    initialAlert,
    alertInfo,
    setAlertInfo,
    setIsLoading: setIsLoadingContext,
  } = UseUpload();
  const { seller_data } = masterdata;
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialPage = (parseInt(queryParams.get("page")) || 1) - 1;
  const initialKeyword = queryParams.get("keyword") || "";
  const { user, checkAllowPermission } = useAuth();

  const [productListData, setProductListData] = useState([]);
  const tableContainerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [tab, setTab] = useState("product"); // product, stock

  const initialStock = {
    stock_id: "", // _id of product_choice
    stock_count: 0,
  };
  const [editStock, setEditStock] = useState(initialStock);

  const [dataSearch, setDataSearch] = useState({
    keyword: initialKeyword,
    page: initialPage,
    page_size: parseInt(queryParams.get("page_size")) || 30,
    status: queryParams.get("status") || "all",
    fromDate: null,
    toDate: queryParams.get("toDate") || dayjs(new Date()).format("YYYY-MM-DD"),
    sortBy: queryParams.get("sortBy") || "createdAt",
    sortOrder: queryParams.get("sortOrder") || "desc",
    seller: queryParams.get("seller") || null,
  });
  const sellerIds = dataSearch?.seller?.split(",");

  useEffect(() => {
    // Update query params
    const newQueryParams = new URLSearchParams();
    newQueryParams.set("page", dataSearch.page + 1);
    newQueryParams.set("keyword", dataSearch.keyword || "");
    newQueryParams.set("page_size", dataSearch.page_size);
    newQueryParams.set("status", dataSearch.status);
    newQueryParams.set("fromDate", dataSearch.fromDate || null);
    newQueryParams.set("toDate", dataSearch.toDate);
    newQueryParams.set("sortBy", dataSearch.sortBy);
    newQueryParams.set("sortOrder", dataSearch.sortOrder);
    newQueryParams.set("seller", dataSearch.seller || "");

    navigate({ search: newQueryParams.toString() });
  }, [dataSearch, navigate]);

  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [formatDataCsv, setFormatDataCsv] = useState([]);
  const [stockDataCsv, setStockDataCsv] = useState([]);
  const [isFetchingDataCsv, setIsFetchingDataCsv] = useState(false);

  const onCopy = async (_id) => {
    await onCopyProduct(_id).then((res) => {
      navigate("/product/upload");
    });
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // fetch all product detail data
  const fetchFormatDataCSV = async () => {
    setIsFetchingDataCsv(true);
    try {
      const pdCsvfetch = await getProductCsvDataAdmin(dataSearch);
      const pdCsvList = JSON.parse(JSON.stringify(pdCsvfetch)).data;

      if (pdCsvList.length > 0) {
        const format = pdCsvList.map((el, index) => {
          const {
            item_code,
            item_name,
            company_name,
            brand_name,
            price,
            start_price,
            special_price,
            url,
            width,
            height,
            thickness,
            category,
            product_types,
            unit_price,
            unit_width,
            unit_height,
            unit_thickness,
            product_features,
            recommend_rooms,
            suitable_areas,
            price_per_sq,
            calculate_size,
            texture_type,
            color,
            sale_unit,
            quantity,
            pattern,
            capacity_size,
            unit_capacity,
            full_sheet,
            cover_image,
            description,
            //   createdAt,
            //   updatedAt,
            //   approvedAt,
            //   approved_by,
          } = el;

          const group_header = {
            ลำดับที่: index + 1,
            รหัสสินค้า: item_code,
            ชื่อสินค้า: item_name,
            ชื่อแบรนด์: brand_name,
            ชื่อบริษัท: company_name,

            ราคาปกติ: price,
            หน่วยขาย: unit_price,
            ราคาพิเศษ: special_price,
            ราคาเริ่มต้น: start_price,
            "ราคาต่อตร.ม.": price_per_sq,

            ผิวสัมผัส: texture_type,
            สี: color,
            ลวดลาย: pattern,

            ...(quantity === "size"
              ? {
                  ความกว้าง: width,
                  หน่วยความกว้าง: unit_width,
                  ความยาว: height,
                  หน่วยความยาว: unit_height,
                  ความหนา: thickness,
                  หน่วยความหนา: unit_thickness,
                }
              : { ปริมาตร: capacity_size, หน่วย: unit_capacity }),

            "จำนวนตร.ม.ต่อหน่วย": calculate_size,
            "จำนวนชิ้น/แผ่น ต่อหน่วย": sale_unit,

            หมวดหมู่: category,
            ประเภท: product_types,
            คุณสมบัติ: product_features,
            ห้องที่ใช้งานได้: recommend_rooms,
            พื้นที่ใช้งาน: suitable_areas,

            รูปเต็ม: full_sheet,
            รูปปก: cover_image,
            คำอธิบาย: description.replace(/<[^>]+>/g, ""),
            ลิงค์สินค้า: url,
            //   วันที่สร้าง: moment(createdAt)
            //     .zone("+0700")
            //     .format("DD/MM/YYYY HH:mm"),
            //   วันที่แก้ไข: moment(updatedAt)
            //     .zone("+0700")
            //     .format("DD/MM/YYYY HH:mm"),
            //   สร้างโดย: created_by,
            //   แก้ไขล่าสุดโดย: updated_by,
            //   วันที่อนุมัติ:
            //     approvedAt && approvedAt !== ""
            //       ? moment(approvedAt).zone("+0700").format("DD/MM/YYYY HH:mm")
            //       : "-",
            //   อนุมัติล่าสุดโดย: approved_by || "-",
          };

          return group_header;
        });

        setFormatDataCsv(format);
      } else {
        setFormatDataCsv([]);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsFetchingDataCsv(false);
    }
  };

  // fetch product stock data
  const fetchStockDataCSV = async () => {
    try {
      setIsFetchingDataCsv(true);

      let sellerId = user?.role_id === 1 ? dataSearch.seller : user?._id;

      const pdCsvfetch = await getProductStockCsvData(sellerId);
      const pdCsvList = JSON.parse(JSON.stringify(pdCsvfetch)).data;

      if (pdCsvList.length > 0) {
        const format = pdCsvList.map((el, index) => {
          const { _id, item_code, item_name, name, is_instock, stock_count } =
            el;

          const group_header = {
            ลำดับที่: index + 1,
            id: _id,
            รหัสสินค้า: item_code,
            ชื่อสินค้า: item_name,
            ชื่อตัวเลือกสินค้า: name || "-",

            สถานะสต็อก: is_instock ? "yes" : "no",
            จำนวนสต็อก: stock_count,
          };

          return group_header;
        });

        setStockDataCsv(format);
      } else {
        setStockDataCsv([]);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsFetchingDataCsv(false);
    }
  };

  const seller_option = seller_data.map((sel) => {
    return {
      ...sel,
      userRoles: [1],
      value: sel.user._id,
      label: sel.seller.company_name,
    };
  });

  const filteredData = sellerIds
    ? seller_option.filter((item) => sellerIds.includes(item.value))
    : [];

  const filterOptions = [
    {
      label: "ทั้งหมด",
      value: "all",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่เป็นฉบับร่าง",
      value: "draft",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่อนุมัติแล้ว",
      value: "approve",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่พักการขาย",
      value: "hold",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่ขอพักการขาย: รออนุมัติ",
      value: "request-hold",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่ขอยกเลิกพักการขาย: รออนุมัติ",
      value: "request-unhold",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าอัพโหลดใหม่: รออนุมัติ",
      value: "new",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่มีการแก้ไข: รออนุมัติ",
      value: "pending",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่ขอลบ: รออนุมัติ",
      value: "request-delete",
      userRoles: [1, 3],
    },
    {
      label: "สินค้าที่ไม่ผ่านการอนุมัติ",
      value: "reject",
      userRoles: [1, 3],
    },
  ];
  const [selectedRows, setSelectedRows] = useState([]);
  const [importFile, setImportFile] = useState();

  // Handle row selection
  const handleSelectRow = (rowId) => {
    setSelectedRows(
      (prevSelected) =>
        prevSelected.includes(rowId)
          ? prevSelected.filter((id) => id !== rowId) // Deselect
          : [...prevSelected, rowId], // Select
    );
  };

  const columns = [
    {
      field: "_id",
      label: "All",
      userRoles: tab === "product" ? [1] : [1, 3],
      width: "10%",
      align: "center",
      sortable: false,
      renderHeader: () => (
        <Checkbox
          sx={{
            "&.Mui-checked": { color: "#e04132" },
            ".MuiSvgIcon-root": { fontSize: "2rem" },
            "&.MuiCheckbox-indeterminate": { color: "#e04132" },
          }}
          checked={isAllSelected}
          indeterminate={
            selectedRows.length > 0 &&
            (tab === "product"
              ? selectedRows.length <
                productListData.filter((fil) => fil.status !== "approve").length
              : selectedRows.length <
                productListData
                  .map((row) => row.choice_all.map(({ choice }) => choice._id))
                  .flat()
                  .filter((id) => id).length)
          }
          onChange={
            tab === "product" ? handleSelectApproveAll : handleSelectStockAll
          }
        />
      ),
      renderCell: (params) =>
        tab === "product" ||
        (tab === "stock" && params?.row?.choice_all?.length === 1) ? (
          <Checkbox
            sx={{
              "&.Mui-checked": {
                color: "#e04132",
              },
              ".MuiSvgIcon-root": {
                fontSize: "2rem",
              },
            }}
            disabled={
              tab === "product"
                ? params?.row?.status === "approve" // Only allow row selection if not approved
                : false
            }
            checked={
              tab === "product" // tab product select product _id, tab stock select product_choice _id
                ? selectedRows.includes(params?.row?._id)
                : selectedRows.includes(params?.row?.choice_all[0]?.choice?._id)
            } // Check if row is selected
            onChange={() =>
              handleSelectRow(
                tab === "product"
                  ? params?.row?._id
                  : params?.row?.choice_all[0]?.choice?._id,
              )
            } // Toggle row selection
          />
        ) : null,
    },
    {
      field: "item_name",
      label: "Product",
      width: "25%",
      sortable: false,
      align: "left",
      userRoles: [1, 3],
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {!!params?.row?.display_img === false ? (
              <ImageEmpty>
                <InsertPhotoIcon
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    cursor: "pointer",
                  }}
                />
              </ImageEmpty>
            ) : (
              <ImgDisplay
                src={
                  params?.row?.display_img
                    ? params?.row?.display_img.replace(".com", ".com/300x300")
                    : ""
                }
                alt={params?.row?.display_img}
              />
            )}
            <Stack style={{ marginLeft: 16 }}>
              <Typography component="span">{params?.row?.item_name}</Typography>
              <Typography component="span">{params?.row?.item_code}</Typography>
              <Typography component="span">
                {params?.row?.category?.cate_th}
              </Typography>
              <Typography component="span">
                {params?.row?.product_types
                  .map((data) => data.type_th)
                  .join(", ")}
              </Typography>
            </Stack>
          </Box>
        );
      },
    },

    ...(tab === "product"
      ? [
          {
            field: "createdAt",
            label: "Created date",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.createdAt
                ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
                : "-",
          },
          {
            field: "updatedAt",
            label: "Updated date",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.updatedAt
                ? dayjs(params?.row?.updatedAt).format("DD-MM-YYYY")
                : "-",
          },
          {
            field: "status",
            label: "Status",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            textTransform: "capitalize",
            renderCell: (params) =>
              params?.row?.status ? params?.row?.status : "",
          },
          {
            field: "is_public",
            label: "Public",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3], // admin
            renderCell: (params) => (
              <FormControlLabel
                sx={{
                  marginInline: 0,
                }}
                control={
                  <IOSSwitch
                    checked={params?.row?.is_public}
                    onChange={(e) => {
                      handleTogglePublic(params.row._id, e.target.checked);
                    }}
                  />
                }
              />
            ),
          },
          {
            field: "actions",
            label: "Actions",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => (
              <Dropdown
                {...params}
                scrollPosition={scrollPosition}
                options={(() => {
                  if (user?.role_id === 1) {
                    if (
                      params.row.status === "pending" ||
                      params.row.status === "new"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "อนุมัติ",
                          startIcon: <GradingIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_approve",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "ลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ประวัติการทำรายการ",
                          startIcon: <HistoryIcon />,
                          onClick: () => {
                            navigate(`/product/logs/${params.row.item_code}`);
                          },
                        },
                      ];
                    } else if (
                      params.row.status === "hold" ||
                      params.row.status_request === "unhold"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "ยกเลิกการพักการขาย",
                          startIcon: <PlayArrowIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการนำสินค้ากลับมาขายใหม่?",
                              onConfirm: () => {
                                onUnHold(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ประวัติการทำรายการ",
                          startIcon: <HistoryIcon />,
                          onClick: () => {
                            navigate(`/product/logs/${params.row.item_code}`);
                          },
                        },
                      ];
                    } else if (
                      params.row.status_request === "delete" ||
                      params.row.status_request === "hold"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label:
                            params.row.status_request === "delete"
                              ? "ยกเลิกคำขอลบสินค้า"
                              : "ยกเลิกคำขอพักการขาย",
                          startIcon: <CancelScheduleSendIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title:
                                "ยืนยันการยกเลิกคำขอลบหรือพักการขายสินค้าทั้งหมด?",
                              onConfirm: () => {
                                onClearRequest(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label:
                            params.row.status_request === "delete"
                              ? "ลบสินค้า"
                              : "พักการขาย",
                          startIcon:
                            params.row.status_request === "delete" ? (
                              <DeleteOutlineRoundedIcon />
                            ) : (
                              <PauseIcon />
                            ),
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            if (params.row.status_request === "delete") {
                              openDialog({
                                type: "confirm",
                                title: "ยืนยันการลบสินค้า?",
                                onConfirm: () => {
                                  onDelete(params.row._id);
                                },
                                maxWidth: 342,
                              });
                            } else {
                              openDialog({
                                type: "confirm",
                                title: "ยืนยันการพักการขายสินค้า?",
                                onConfirm: () => {
                                  onHold(params.row._id);
                                },
                                maxWidth: 342,
                              });
                            }
                          },
                        },
                        {
                          label: "ประวัติการทำรายการ",
                          startIcon: <HistoryIcon />,
                          onClick: () => {
                            navigate(`/product/logs/${params.row.item_code}`);
                          },
                        },
                      ];
                    } else if (
                      params.row.status === "approve" ||
                      params.row.status === "reject"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขสินค้า",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "พักการขาย",
                          startIcon: <PauseIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการพักการขายสินค้า?",
                              onConfirm: () => {
                                onHold(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ประวัติการทำรายการ",
                          startIcon: <HistoryIcon />,
                          onClick: () => {
                            navigate(`/product/logs/${params.row.item_code}`);
                          },
                        },
                      ];
                    } else if (params.row.status === "draft") {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "ลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                      ];
                    }
                  } else {
                    if (
                      params.row.status === "pending" ||
                      params.row.status === "new"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                      ];
                    } else if (
                      params.row.status_request === "delete" ||
                      params.row.status_request === "hold" ||
                      params.row.status_request === "unhold"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                      ];
                    } else if (
                      params.row.status === "approve" ||
                      params.row.status === "reject"
                    ) {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "ขอพักการขาย",
                          startIcon: <PauseIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการพักการขายสินค้า?",
                              onConfirm: () => {
                                onHold(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ขอลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                      ];
                    } else if (params.row.status === "hold") {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "ขอยกเลิกพักการขาย",
                          startIcon: <PlayArrowIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการนำสินค้ากลับมาขายใหม่?",
                              onConfirm: () => {
                                onUnHold(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                        {
                          label: "ขอลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                      ];
                    } else if (params.row.status === "draft") {
                      return [
                        {
                          label: "ดูตัวอย่าง",
                          startIcon: <VisibilityIcon />,
                          onClick: () => {
                            openDialog({
                              type: "custom",
                              customDialog: (
                                <ApproveProduct
                                  onClose={() => closeDialog()}
                                  productId={params?.row?._id}
                                  dataSearch={dataSearch}
                                  setProductListData={setProductListData}
                                  setRowCount={setRowCount}
                                />
                              ),
                            });
                          },
                        },
                        {
                          label: "แก้ไขรายละเอียด",
                          startIcon: <EditRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_create",
                          ),
                          onClick: () =>
                            navigate(`/product/upload/${params.row._id}`),
                        },
                        {
                          label: "คัดลอกสินค้า",
                          startIcon: <ContentCopyIcon />,
                          disabled: !checkAllowPermission("products.can_edit"),
                          onClick: () => onCopy(params.row._id),
                        },
                        {
                          label: "ลบสินค้า",
                          startIcon: <DeleteOutlineRoundedIcon />,
                          disabled: !checkAllowPermission(
                            "products.can_hold_delete",
                          ),
                          onClick: () => {
                            openDialog({
                              type: "confirm",
                              title: "ยืนยันการลบสินค้า?",
                              onConfirm: () => {
                                onDelete(params.row._id);
                              },
                              maxWidth: 342,
                            });
                          },
                        },
                      ];
                    }
                  }
                })()}
              />
            ),
          },
        ]
      : []),

    ...(tab === "stock"
      ? [
          {
            field: "stock_date",
            label: "Updated date",
            width: "17%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.choice_all?.length === 1
                ? params?.row?.choice_all[0]?.choice?.stock_date
                  ? dayjs(
                      params?.row?.choice_all[0]?.choice?.stock_date,
                    ).format("DD-MM-YYYY")
                  : "-"
                : null,
          },
          {
            field: "is_stock",
            label: "Stock",
            width: "17%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.choice_all?.length === 1 ? (
                <FormControlLabel
                  sx={{
                    marginInline: 0,
                  }}
                  control={
                    <IOSSwitch
                      checked={params?.row?.choice_all[0]?.choice?.is_instock}
                      // onChange={(e) => {
                      //   handleToggleStock(
                      //     params?.row?.choice_all[0]?.choice?._id,
                      //     e.target.checked,
                      //   );
                      // }}
                      onChange={(e) => {
                        handleUpdateStock(
                          params?.row?.choice_all[0]?.choice?._id,
                          {
                            is_instock: e.target.checked,
                            stock_count:
                              params?.row?.choice_all[0]?.choice?.stock_count ||
                              null,
                          },
                        );
                      }}
                    />
                  }
                />
              ) : null,
          },
          {
            field: "stock_count",
            label: "Amount",
            width: "17%",
            sortable: false,
            align: "center",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.choice_all?.length === 1 ? (
                <>
                  {editStock.stock_id ===
                  params.row.choice_all[0]?.choice?._id ? (
                    <TextField
                      value={editStock.stock_count || ""}
                      onChange={(e) => {
                        if (e.target.value * 0 === 0) {
                          setEditStock({
                            ...editStock,
                            stock_count: e.target.value,
                          });
                        }
                      }}
                      onBlur={(e) => {
                        if (e.target.value * 0 === 0) {
                          setEditStock({
                            ...editStock,
                            stock_count: parseInt(e.target.value) || null,
                          });
                        }
                      }}
                    />
                  ) : (
                    <Typography component="span" fontSize={14}>
                      {!!params?.row?.choice_all[0]?.choice?.stock_count
                        ? convertIntToCurrency(
                            params?.row?.choice_all[0]?.choice?.stock_count,
                            false,
                          )
                        : "-"}
                    </Typography>
                  )}
                </>
              ) : null,
          },
          {
            field: "actions",
            label: "Actions",
            width: "14%",
            sortable: false,
            align: "center",
            userRoles: [1, 3],
            renderCell: (params) => {
              if (params?.row?.choice_all?.length === 1) {
                return (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", gap: 1.5 }}
                  >
                    {editStock.stock_id ===
                    params.row.choice_all[0]?.choice?._id ? (
                      <>
                        <IconButton
                          variant="contained"
                          size="small"
                          style={{
                            width: 40,
                            height: 40,
                            padding: "8px",
                            color: White,
                            backgroundColor: Colors.Error,
                            borderRadius: "50%",
                          }}
                          onClick={() => setEditStock(initialStock)}
                        >
                          <CloseIcon />
                        </IconButton>

                        <IconButton
                          variant="outlined"
                          size="small"
                          style={{
                            width: 40,
                            height: 40,
                            padding: "8px",
                            color: White,
                            backgroundColor: Colors.Success,
                            borderRadius: "50%",
                          }}
                          onClick={() =>
                            handleUpdateStock(
                              params?.row?.choice_all[0]?.choice?._id,
                              {
                                is_instock:
                                  params?.row?.choice_all[0]?.choice
                                    ?.is_instock,
                                stock_count: editStock.stock_count,
                              },
                            )
                          }
                        >
                          <SaveIcon />
                        </IconButton>
                      </>
                    ) : (
                      <IconButton
                        variant="outlined"
                        size="small"
                        style={{
                          width: 40,
                          height: 40,
                          padding: "8px",
                          borderRadius: "50%",
                        }}
                        onClick={() =>
                          setEditStock({
                            stock_id: params.row.choice_all[0]?.choice?._id,
                            stock_count:
                              params?.row?.choice_all[0]?.choice?.stock_count,
                          })
                        }
                      >
                        <EditRoundedIcon />
                      </IconButton>
                    )}
                  </Box>
                );
              }
            },
          },
        ]
      : []),
  ];

  const subTableDataField = "choice_all";
  const subTableColumns = [
    {
      field: "_id",
      label: "",
      width: tab === "product" ? "6%" : "10%",
      sortable: true,
      align: "center",
      userRoles: tab === "product" ? [1] : [1, 3],
      renderCell: (params) =>
        tab === "stock" ? (
          <Checkbox
            sx={{
              "&.Mui-checked": {
                color: "#e04132",
              },
              ".MuiSvgIcon-root": {
                fontSize: "2rem",
              },
            }}
            checked={selectedRows.includes(params?.row?.choice?._id)} // Check if row is selected
            onChange={() => handleSelectRow(params?.row?.choice?._id)} // Toggle row selection
          />
        ) : null,
    },
    {
      field: "item_name",
      label: "Product",
      width: "25%",
      sortable: false,
      align: "left",
      userRoles: [1, 3],
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
            style={{
              paddingLeft:
                tab === "product" ? (user?.role_id === 1 ? 48 : 24) : 12,
            }}
          >
            {!!params?.row?.choice?.group_image.product_display_image ===
            false ? (
              <ImageEmpty>
                <InsertPhotoIcon
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    cursor: "pointer",
                  }}
                />
              </ImageEmpty>
            ) : (
              <ImgDisplay
                style={{
                  width: 80,
                  height: 80,
                }}
                src={
                  params?.row?.choice?.group_image.product_display_image
                    ? params?.row?.choice?.group_image.product_display_image.replace(
                        ".com",
                        ".com/300x300",
                      )
                    : ""
                }
                alt={params?.row?.choice?.name}
              />
            )}
            <Stack style={{ marginLeft: 16 }}>
              <Typography component="span" fontSize={14}>
                {params?.row?.choice?.name}
              </Typography>
            </Stack>
          </Box>
        );
      },
    },

    ...(tab === "product"
      ? [
          {
            field: "createdAt",
            label: "Created date",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => "-",
          },
          {
            field: "updatedAt",
            label: "Updated date",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => "-",
          },
          {
            field: "status",
            label: "Status",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => "-",
          },
          {
            field: "is_public",
            label: "Public",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3], // admin
            renderCell: (params) => {},
          },
          {
            field: "actions",
            label: "Actions",
            width: user?.role_id === 1 ? "13%" : "15%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => {}, // Render empty for sub-table actions
          },
        ]
      : []),

    ...(tab === "stock"
      ? [
          {
            field: "stock_date",
            label: "Updated date",
            width: "17%",
            sortable: true,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) =>
              params?.row?.choice?.stock_date
                ? dayjs(params?.row?.choice?.stock_date).format("DD-MM-YYYY")
                : "-",
          },
          {
            field: "is_stock",
            label: "Stock",
            width: "17%",
            sortable: false,
            align: "right",
            userRoles: [1, 3],
            renderCell: (params) => (
              <FormControlLabel
                sx={{
                  marginInline: 0,
                }}
                control={
                  <IOSSwitch
                    checked={params?.row?.choice?.is_instock}
                    // onChange={(e) => {
                    //   handleToggleStock(
                    //     params.row?.choice?._id,
                    //     e.target.checked,
                    //   );
                    // }}
                    onChange={(e) => {
                      handleUpdateStock(params.row?.choice?._id, {
                        is_instock: e.target.checked,
                        stock_count: params.row?.choice?.stock_count || null,
                      });
                    }}
                  />
                }
              />
            ),
          },
          {
            field: "stock_count",
            label: "Amount",
            width: "17%",
            sortable: false,
            align: "center",
            userRoles: [1, 3],
            renderCell: (params) => (
              <>
                {editStock.stock_id === params?.row?.choice?._id ? (
                  <TextField
                    value={editStock.stock_count || ""}
                    onChange={(e) => {
                      if (e.target.value * 0 === 0) {
                        setEditStock({
                          ...editStock,
                          stock_count: e.target.value,
                        });
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value * 0 === 0) {
                        setEditStock({
                          ...editStock,
                          stock_count: parseInt(e.target.value) || null,
                        });
                      }
                    }}
                  />
                ) : (
                  <Typography component="span" fontSize={14}>
                    {!!params?.row?.choice?.stock_count
                      ? convertIntToCurrency(
                          params?.row?.choice?.stock_count,
                          false,
                        )
                      : "-"}
                  </Typography>
                )}
              </>
            ),
          },
          {
            field: "actions",
            label: "Actions",
            width: "14%",
            sortable: false,
            align: "center",
            userRoles: [1, 3],
            renderCell: (params) => (
              <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                {editStock.stock_id === params?.row?.choice?._id ? (
                  <>
                    <IconButton
                      variant="contained"
                      size="small"
                      style={{
                        width: 40,
                        height: 40,
                        padding: "8px",
                        color: White,
                        backgroundColor: Colors.Error,
                        borderRadius: "50%",
                      }}
                      onClick={() => setEditStock(initialStock)}
                    >
                      <CloseIcon />
                    </IconButton>

                    <IconButton
                      variant="outlined"
                      size="small"
                      style={{
                        width: 40,
                        height: 40,
                        padding: "8px",
                        color: White,
                        backgroundColor: Colors.Success,
                        borderRadius: "50%",
                      }}
                      onClick={() =>
                        handleUpdateStock(params?.row?.choice?._id, {
                          is_instock: params?.row?.choice?.is_instock,
                          stock_count: editStock.stock_count,
                        })
                      }
                    >
                      <SaveIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    variant="outlined"
                    size="small"
                    style={{
                      width: 40,
                      height: 40,
                      padding: "8px",
                      borderRadius: "50%",
                    }}
                    onClick={() =>
                      setEditStock({
                        stock_id: params.row?.choice?._id,
                        stock_count: params?.row?.choice?.stock_count,
                      })
                    }
                  >
                    <EditRoundedIcon />
                  </IconButton>
                )}
              </Box>
            ),
          },
        ]
      : []),
  ];

  const visibleColumns = columns.filter((col) =>
    col.userRoles.includes(user?.role_id),
  );

  const visibleSubColumns =
    subTableColumns?.filter((col) => col.userRoles.includes(user?.role_id)) ||
    [];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  // function NoResultsOverlay() {
  // 	return (
  // 		<Stack height='100%' alignItems='center' justifyContent='center'>
  // 			<ImageNotFound></ImageNotFound>
  // 			<TextNoData>Not Found</TextNoData>
  // 		</Stack>
  // 	);
  // }

  const onDelete = (productId) => {
    if (productId === null) return;
    // setIsLoading(true);

    const deletePromise =
      user?.role_id === 1
        ? deleteProduct(productId)
        : requestDeleteProduct(productId);

    deletePromise
      .then((res) => {
        (async () => {
          const { data } = await (user?.role_id === 1
            ? getProductListAdmin(dataSearch)
            : getProductListSeller(dataSearch));
          setProductListData(data.rows);
          setRowCount(data.count);
          // setIsLoading(false);
          enqueueSnackbar("Delete Success", {
            variant: "success",
          });
          closeDialog();
        })();
      })
      .catch((err) => {
        // setIsLoading(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        closeDialog();
      });
  };

  const onHold = (productId) => {
    if (productId === null) return;
    // setIsLoading(true);
    const holdPromise =
      user?.role_id === 1
        ? holdProduct(productId)
        : requestHoldProduct(productId);

    holdPromise
      .then((res) => {
        (async () => {
          const { data } = await (user?.role_id === 1
            ? getProductListAdmin(dataSearch)
            : getProductListSeller(dataSearch));
          setProductListData(data.rows);
          setRowCount(data.count);
          // setIsLoading(false);
          enqueueSnackbar("Hold Success", {
            variant: "success",
          });
          closeDialog();
        })();
      })
      .catch((err) => {
        // setIsLoading(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        closeDialog();
      });
  };

  const onUnHold = (productId) => {
    if (productId === null) return;
    // setIsLoading(true);
    const unHoldPromise =
      user?.role_id === 1
        ? unHoldProduct(productId)
        : requestUnHoldProduct(productId);

    unHoldPromise
      .then((res) => {
        (async () => {
          const { data } = await (user?.role_id === 1
            ? getProductListAdmin(dataSearch)
            : getProductListSeller(dataSearch));
          setProductListData(data.rows);
          setRowCount(data.count);
          // setIsLoading(false);
          enqueueSnackbar("UnHold Success", {
            variant: "success",
          });
          closeDialog();
        })();
      })
      .catch((err) => {
        // setIsLoading(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        closeDialog();
      });
  };

  const onClearRequest = (productId) => {
    if (productId === null) return;
    // setIsLoading(true);
    const clearRequestPromise = clearRequestProduct(productId);

    clearRequestPromise
      .then((res) => {
        (async () => {
          const { data } = await getProductListAdmin(dataSearch);
          setProductListData(data.rows);
          setRowCount(data.count);
          // setIsLoading(false);
          enqueueSnackbar("ClearRequest Success", {
            variant: "success",
          });
          closeDialog();
        })();
      })
      .catch((err) => {
        // setIsLoading(false);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        closeDialog();
      });
  };

  const onSearchButton = () => {
    setIsLoading(true);
    setDataSearch({ ...dataSearch, page: 0 });

    queryParams.set("page", 1);
    navigate({ search: queryParams.toString() });
    if (dataSearch.keyword) {
      queryParams.set("keyword", dataSearch.keyword); // Add keyword to query params
    } else {
      queryParams.delete("keyword"); // Remove keyword if empty
    }

    // setIsLoading(true);
    (async () => {
      if (user?.role_id === 1) {
        const { data } = await getProductListAdmin({
          ...dataSearch,
          page: 0,
        });
        setProductListData(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      } else if (user?.role_id === 3) {
        const { data } = await getProductListSeller({
          ...dataSearch,
          page: 0,
        });
        setProductListData(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const totalPages = Math.ceil(rowCount / dataSearch.page_size);

  const handlePageChange = (newPage) => {
    const updatedPage = newPage;
    const validPage = Math.max(updatedPage, 0);
    setDataSearch({ ...dataSearch, page: validPage });

    // Update query parameter in URL
    queryParams.set("page", validPage + 1);
    navigate({ search: queryParams.toString() });
  };

  const handlePageInputChange = (event) => {
    let inputValue = event.target.value;

    inputValue = inputValue.replace(/[^0-9]/g, "");
    if (!inputValue || inputValue === "") {
      setDataSearch((prev) => ({
        ...prev,
        page: 0,
      }));
    } else {
      let inputPage = parseInt(inputValue, 10);
      if (!isNaN(inputPage) && inputPage > 0 && inputPage <= totalPages) {
        queryParams.set("page", inputValue);
        navigate({ search: queryParams.toString() });
        setDataSearch((prev) => ({
          ...prev,
          page: inputPage - 1,
        }));
      }
    }
  };

  const handleSort = (sortBy) => {
    setDataSearch({
      ...dataSearch,
      sortBy: sortBy,
      sortOrder:
        dataSearch.sortBy === sortBy && dataSearch.sortOrder === "asc"
          ? "desc"
          : "asc",
    });
  };

  const handleTogglePublic = async (id, is_public) => {
    await updateProductPublic(id, is_public);

    let updatedProductList = productListData.map((product) => {
      if (product._id === id) {
        return {
          ...product,
          is_public: is_public,
        };
      } else {
        return product;
      }
    });

    setProductListData(updatedProductList);
  };

  // const handleToggleStock = async (id, is_instock) => {
  //   await updateProductStock(id, is_instock);

  //   let updatedProductList = productListData.map((product) => {
  //     return {
  //       ...product,
  //       choice_all: product.choice_all.map((choice) => {
  //         if (choice?.choice?._id === id) {
  //           return {
  //             ...choice,
  //             choice: {
  //               ...choice.choice,
  //               is_instock: is_instock,
  //             },
  //           };
  //         } else {
  //           return choice;
  //         }
  //       }),
  //     };
  //   });

  //   setProductListData(updatedProductList);
  // };

  /**
   *
   * @param {string} id - choice_id
   * @param {object} info - { is_instock: boolean, stock_count: number }
   * @param {object} info.is_instock - boolean
   * @param {object} info.stock_count - number
   */
  const handleUpdateStock = async (id, info) => {
    // console.log("info", info);
    await updateProductStockInfo(id, info);

    let updatedProductList = productListData.map((product) => {
      return {
        ...product,
        choice_all: product.choice_all.map((choice) => {
          if (choice?.choice?._id === id) {
            return {
              ...choice,
              choice: {
                ...choice.choice,
                is_instock: info.is_instock,
                stock_count: info.stock_count,
                stock_date: new Date(),
              },
            };
          } else {
            return choice;
          }
        }),
      };
    });

    setProductListData(updatedProductList);
    setEditStock(initialStock);
  };

  /**
   *
   * @param {file} fileCallBlack - csv file
   */
  const handleImportFile = async (fileCallBlack) => {
    try {
      setIsLoading(true);
      setIsLoadingContext(true);

      await importProductStockCsvData({
        userId: user.role_id === 1 ? dataSearch.seller : user._id,
        stock_csv: fileCallBlack,
      });

      if (user?.role_id === 1) {
        const { data } = await getProductListAdmin(dataSearch);
        setProductListData(data.rows);
        setRowCount(data.count);
      } else if (user?.role_id === 3) {
        const { data } = await getProductListSeller(dataSearch);
        setProductListData(data.rows);
        setRowCount(data.count);
      }
    } catch (error) {
      console.error("Error importing CSV file:", error);
    } finally {
      setIsLoading(false);
      setIsLoadingContext(false);
    }
  };

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        setSelectedRows([]);
        if (user?.role_id === 1) {
          const { data } = await getProductListAdmin(dataSearch);
          setProductListData(data.rows);
          setRowCount(data.count);
          setIsLoading(false);
        } else if (user?.role_id === 3) {
          const { data } = await getProductListSeller(dataSearch);
          setProductListData(data.rows);
          setRowCount(data.count);
          setIsLoading(false);
        }
      } catch (err) {
        // console.log(err.message, '======= log log log');
      }
      // if (profile.role_id === 1) {
      //   const { data } = await getProductListAdmin(dataSearch);
      //   setProductListData(data.rows);
      //   setRowCount(data.count);
      //   setIsLoading(false);
      // } else if (profile.role_id === 3) {
      //   const { data } = await getProductListSeller(dataSearch);
      //   setProductListData(data.rows);
      //   setRowCount(data.count);
      //   setIsLoading(false);
      // }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dataSearch.page,
    dataSearch.status,
    dataSearch.fromDate,
    dataSearch.toDate,
    dataSearch.sortBy,
    dataSearch.sortOrder,
    dataSearch.seller,
    user,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      if (tableContainerRef.current) {
        const scrollTop = tableContainerRef.current.scrollTop;
        setScrollPosition(scrollTop);
      }
    };

    if (tableContainerRef.current) {
      tableContainerRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (tableContainerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        tableContainerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTo(0, 0);
      setSelectedRows([]);
    }
  }, [dataSearch.page]);

  useEffect(() => {
    setSelectedRows([]);
    setDataSearch({
      ...dataSearch,
      page: 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  useEffect(() => {
    setDataSearch((prev) => ({ ...prev, page: initialPage }));
  }, [initialPage]);

  useEffect(() => {
    if (tab === "product" && fetchCsvCondition) {
      fetchFormatDataCSV();
    }
    if (tab === "stock" && fetchStockCsvCondition) {
      fetchStockDataCSV();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch]);

  // Handle Select All
  const handleSelectApproveAll = (event) => {
    if (event.target.checked) {
      const allRowIds = productListData
        .filter((fil) => fil.status !== "approve")
        .map((row) => row._id);
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  // Handle Select All
  const handleSelectStockAll = (event) => {
    if (event.target.checked) {
      const allRowIds = productListData
        .map((row) => row.choice_all.map(({ choice }) => choice._id))
        .flat()
        .filter((id) => id); // Filter out undefined or null IDs
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  const isAllSelected =
    productListData.filter((fil) => fil.status !== "approve").length > 0 &&
    (tab === "product"
      ? selectedRows.length ===
        productListData.filter((fil) => fil.status !== "approve").length
      : selectedRows.length ===
        productListData
          .map((row) => row.choice_all.map(({ choice }) => choice._id))
          .flat()
          .filter((id) => id).length);

  const handleApproveAll = async () => {
    setIsLoadingContext(true);

    await approveAllSelectedProduct(selectedRows)
      .then((res) => {
        setIsLoading(false);
        setIsLoadingContext({
          ...alertInfo,
          visible: true,
          textError: "สำเร็จ",
          typeError: "success",
        });
        setTimeout(async () => {
          setAlertInfo(initialAlert);
          const { data } = await getProductListAdmin(dataSearch);
          setProductListData(data.rows);
          setRowCount(data.count);
          setSelectedRows([]);
          setIsLoading(false);
          setIsLoadingContext(false);
        }, 1500);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.response.data.message,
          typeError: "error",
        });
        setTimeout(() => {
          setIsLoading(false);
          setIsLoadingContext(false);
          setAlertInfo(initialAlert);
        }, 2500);
      });
  };

  /**
   *
   * @param {boolean} stockStatus - true = in stock, false = out of stock
   */
  const handleStockAll = async (stockStatus) => {
    setIsLoadingContext(true);

    await updateMultipleStock(selectedRows, stockStatus)
      .then((res) => {
        setIsLoading(false);
        setIsLoadingContext({
          ...alertInfo,
          visible: true,
          textError: "สำเร็จ",
          typeError: "success",
        });
        setTimeout(async () => {
          setAlertInfo(initialAlert);
          // if (user?.role_id === 1) {
          //   const { data } = await getProductListAdmin(dataSearch);
          //   setProductListData(data.rows);
          //   setRowCount(data.count);
          // } else if (user?.role_id === 3) {
          //   const { data } = await getProductListSeller(dataSearch);
          //   setProductListData(data.rows);
          //   setRowCount(data.count);
          // }
        }, 1500);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertInfo({
          ...alertInfo,
          visible: true,
          textError: err.response.data.message,
          typeError: "error",
        });
        setTimeout(() => {
          setIsLoading(false);
          setIsLoadingContext(false);
          setAlertInfo(initialAlert);
        }, 2500);
      })
      .finally(() => {
        setSelectedRows([]);
        setIsLoading(false);
        setIsLoadingContext(false);
      });

    let updatedProductList = productListData.map((product) => {
      return {
        ...product,
        choice_all: product.choice_all.map((choice) => {
          return {
            ...choice,
            choice: {
              ...choice.choice,
              is_instock: stockStatus,
              stock_date: new Date(),
            },
          };
        }),
      };
    });

    setProductListData(updatedProductList);
  };

  // Handle change event to update selected values
  const handleChange = (event, value) => {
    queryParams.set("page", 1);
    navigate({ search: queryParams.toString() });
    setDataSearch({
      ...dataSearch,
      seller: value.map((mp) => mp.value).join(","),
    }); // Store the selected options
  };

  const handleChangeStatus = (event) => {
    queryParams.set("page", 1);
    navigate({ search: queryParams.toString() });
    setDataSearch({
      ...dataSearch,
      page: 0,
      status: event.target.value,
    });
  };

  const fetchCsvCondition =
    dataSearch?.status !== "all" &&
    dataSearch?.seller?.split(",").length === 1 &&
    dataSearch?.seller !== ""; //when deselect - seller value will be ""

  const productExportCsvCondition =
    !isFetchingDataCsv &&
    dataSearch.status !== "all" &&
    formatDataCsv.length > 0 &&
    dataSearch?.seller?.trim() !== "" &&
    dataSearch?.seller?.split(",").length === 1;

  const fetchStockCsvCondition =
    user?.role_id === 1 // only admin
      ? dataSearch?.seller?.split(",").length === 1 && dataSearch?.seller !== "" // when deselect - seller value will be ""
      : true; // seller can export all

  const stockImportCsvCondition =
    user?.role_id === 1
      ? dataSearch?.seller?.trim() !== "" &&
        dataSearch?.seller?.split(",").length === 1
      : true;

  const stockExportCsvCondition =
    !isFetchingDataCsv &&
    stockDataCsv.length > 0 &&
    (user?.role_id === 1
      ? dataSearch?.seller?.trim() !== "" &&
        dataSearch?.seller?.split(",").length === 1
      : true);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />

        <DivMuiName>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: "1 1 auto",
                width: "80%",
              }}
            >
              <MuiTextField
                id="search-input"
                placeholder="ค้นหาสินค้าจากชื่อ หรือ รหัสสินค้า"
                className="MuiTextField-without-border-radius"
                sx={{
                  width: "35%",
                  maxWidth: "100%",
                  // minWidth: 250,
                  flexShrink: 0,
                  marginRight: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <SearchIcon
                      sx={{
                        color: "#e04132",
                        cursor: "pointer",
                      }}
                    />
                    // <IconButton
                    //   sx={{ padding: 0 }}
                    //   onClick={() => {
                    //     onSearchButton();
                    //   }}
                    // >
                    //   <SearchIcon
                    //     sx={{
                    //       color: "#e04132",
                    //       cursor: "pointer",
                    //     }}
                    //   />
                    // </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({
                    ...dataSearch,
                    keyword: e.target.value,
                  });
                }}
                value={dataSearch.keyword}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />

              <FormControl
                sx={{
                  width: "30%",
                  maxWidth: "100%",
                  // minWidth: 130,
                  flexShrink: 0,
                }}
              >
                <InputLabel id="status-select-label">Status</InputLabel>
                <Select
                  labelId="status-select-label"
                  label="Status"
                  id="status-select"
                  onChange={(e) => handleChangeStatus(e)}
                  value={dataSearch.status}
                >
                  {filterOptions?.map((option) => {
                    const shouldDisplayOption = option.userRoles.includes(
                      user?.role_id,
                    );
                    if (shouldDisplayOption) {
                      return (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>

              {user?.role_id === 1 && (
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  limitTags={1}
                  options={seller_option}
                  value={filteredData}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  onChange={handleChange}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    );
                  }}
                  sx={{
                    width: "35%",
                    // minWidth: 160,
                    ml: "16px",
                  }}
                  renderInput={(params) => (
                    <MuiTextField
                      {...params}
                      label="Seller"
                      placeholder="company"
                    />
                  )}
                />
              )}
            </Box>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/product/upload")}
              disabled={!checkAllowPermission("products.can_create")}
              size="large"
              sx={{ minWidth: 170 }}
            >
              อัพโหลดสินค้า
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                }}
                component="span"
              >
                สินค้าทั้งหมด :{" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#E13B30",
                  }}
                >
                  {rowCount}
                </Typography>
              </Typography>
              {user?.role_id === 1 ? (
                <Typography
                  component="span"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    navigate("/product/logs");
                  }}
                >
                  <RestoreIcon
                    sx={{
                      mr: 1,
                    }}
                  />{" "}
                  ประวัติการทำรายการ
                </Typography>
              ) : null}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mr: 2,
                }}
              >
                Sort by :{" "}
                <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
                  <Select
                    value={dataSearch.sortBy}
                    onChange={(e) => handleSort(e.target.value)}
                    // IconComponent={ExpandMore}
                    // sx={{
                    //   "& .MuiSelect-select": {
                    //     color: "#E13B30",
                    //   },
                    // }}
                  >
                    <MenuItem value="createdAt">Created Date</MenuItem>
                    <MenuItem value="updatedAt">Updated Date</MenuItem>
                  </Select>
                </FormControl>
              </Box> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  From :{" "}
                  <DatePicker
                    value={dataSearch.fromDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const formattedDate = dayjs(newValue).isValid()
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : null;
                      setDataSearch({
                        ...dataSearch,
                        fromDate: formattedDate,
                        page: 0,
                      });
                    }}
                    maxDate={dayjs(new Date())}
                    renderInput={(params) => (
                      <MuiTextField
                        onKeyDown={onKeyDown}
                        {...params}
                        inputProps={{ ...params.inputProps, readOnly: true }}
                        sx={{
                          mx: 1,
                          width: "100%",
                          maxWidth: 200,
                          background: "#fff",
                          ".MuiOutlinedInput-root": {
                            paddingRight: "18px",
                          },
                        }}
                      />
                    )}
                  />
                  to
                  <DatePicker
                    value={dataSearch.toDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const formattedDate = dayjs(newValue).isValid()
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : dayjs(new Date()).format("YYYY-MM-DD");
                      setDataSearch({
                        ...dataSearch,
                        toDate: formattedDate,
                        page: 0,
                      });
                    }}
                    minDate={dayjs(dataSearch.fromDate)}
                    maxDate={dayjs(new Date())}
                    renderInput={(params) => (
                      <MuiTextField
                        onKeyDown={onKeyDown}
                        {...params}
                        inputProps={{ ...params.inputProps, readOnly: true }}
                        sx={{
                          ml: 1,
                          width: "100%",
                          maxWidth: 200,
                          background: "#fff",
                          ".MuiOutlinedInput-root": {
                            paddingRight: "18px",
                          },
                        }}
                      />
                    )}
                  />
                </Box>
              </LocalizationProvider>
            </Box>
          </Box>

          {tab === "product" && user?.role_id === 1 && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mr: 2,
                }}
              >
                <div>
                  <Typography sx={{}} component="span">
                    สินค้าที่ถูกเลือก :{" "}
                    <Typography
                      component="span"
                      sx={{
                        color: "#E13B30",
                      }}
                    >
                      {selectedRows.length}
                    </Typography>{" "}
                    รายการ
                  </Typography>

                  <Button
                    sx={{ alignItems: "center", ml: 2 }}
                    variant="contained"
                    disabled={selectedRows.length === 0}
                    onClick={() => {
                      openDialog({
                        type: "confirm",
                        title: `ต้องการยืนยันสินค้าจำนวน ${selectedRows.length} รายการนี้หรือไม่ ?`,
                        onConfirm: () => {
                          handleApproveAll();
                        },
                        maxWidth: 342,
                      });
                    }}
                    size="large"
                  >
                    Approve All
                  </Button>
                </div>

                <div>
                  <Button variant="text">
                    <CSVLink
                      style={{
                        display: "flex",
                        fontWeight: "500",
                        fontSize: "15px",
                        justifyContent: "end ",
                        alignItems: "center",
                        color: productExportCsvCondition
                          ? `${Primary}`
                          : `${Grey}`,
                        fontStyle: "normal",
                        cursor: productExportCsvCondition
                          ? "pointer"
                          : "no-drop",
                        pointerEvents: productExportCsvCondition
                          ? "auto"
                          : "none",
                      }}
                      data={formatDataCsv}
                      filename={`${
                        dataSearch.status === "new" ? "new" : "updated"
                      }-product-${dayjs(new Date()).format("DD-MM-YYYY")}.csv`}
                      onClick={(event, done) => {
                        if (!productExportCsvCondition) {
                          return false;
                        }
                      }}
                    >
                      <FileUploadIcon /> Export
                    </CSVLink>
                  </Button>
                </div>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  mr: 2,
                  my: 2,
                }}
              >
                <Typography
                  sx={{
                    color: productExportCsvCondition ? Grey : Primary,
                    fontSize: "12px",
                  }}
                >
                  {isFetchingDataCsv
                    ? `กำลังดาวน์โหลดไฟล์...`
                    : `  หมายเหตุ:
                  ระบบจะสามารถส่งออกข้อมูลได้เมื่อมีการเลือกสถานะที่ไม่ใช่
                  'ทั้งหมด' และเลือก 'ร้านค้าเพียง 1 ร้านเท่านั้น'`}
                </Typography>
              </Box>
            </>
          )}

          {tab === "stock" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mr: 2,
                }}
              >
                <div>
                  <Typography sx={{}} component="span">
                    สินค้าที่ถูกเลือก :{" "}
                    <Typography
                      component="span"
                      sx={{
                        color: "#E13B30",
                      }}
                    >
                      {selectedRows.length}
                    </Typography>{" "}
                    รายการ
                  </Typography>

                  <Button
                    sx={{ alignItems: "center", ml: 2 }}
                    variant="contained"
                    disabled={selectedRows.length === 0}
                    onClick={() => {
                      openDialog({
                        type: "confirm",
                        title: `ต้องการเปิดสต็อคสินค้าจำนวน ${selectedRows.length} รายการนี้หรือไม่ ?`,
                        onConfirm: () => {
                          handleStockAll(true);
                        },
                        maxWidth: 342,
                      });
                    }}
                    size="large"
                  >
                    Open Stock
                  </Button>

                  <Button
                    sx={{ alignItems: "center", ml: 2 }}
                    variant="secondary"
                    disabled={selectedRows.length === 0}
                    onClick={() => {
                      openDialog({
                        type: "confirm",
                        title: `ต้องการปิดสต็อคสินค้าจำนวน ${selectedRows.length} รายการนี้หรือไม่ ?`,
                        onConfirm: () => {
                          handleStockAll(false);
                        },
                        maxWidth: 342,
                      });
                    }}
                    size="large"
                  >
                    Close Stoke
                  </Button>
                </div>

                {/* import / export stock info */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Button variant="text" disabled={!stockExportCsvCondition}>
                    <CSVLink
                      style={{
                        display: "flex",
                        fontWeight: "500",
                        fontSize: "15px",
                        justifyContent: "end ",
                        alignItems: "center",
                        gap: "8px",
                        color: stockExportCsvCondition
                          ? `${Primary}`
                          : `${Grey}`,
                        fontStyle: "normal",
                        cursor: stockExportCsvCondition ? "pointer" : "no-drop",
                        pointerEvents: stockExportCsvCondition
                          ? "auto"
                          : "none",
                      }}
                      data={stockDataCsv}
                      filename={`stock-product-${dayjs(new Date()).format("DD-MM-YYYY")}.csv`}
                      onClick={(event, done) => {
                        if (!stockExportCsvCondition) {
                          return false;
                        }
                      }}
                    >
                      <FileUploadIcon /> Export stock File
                    </CSVLink>
                  </Button>

                  <UploadFile
                    callBackFile={(fileCallBlack) =>
                      handleImportFile(fileCallBlack)
                    }
                    closeAlert={false}
                    acceptFileType={[".csv", ".xlsx"]}
                    onClick={() => {
                      if (!stockImportCsvCondition) {
                        return false;
                      }
                    }}
                  >
                    <Button
                      variant="text"
                      color="secondary"
                      startIcon={<FileDownloadIcon />}
                      disabled={!stockImportCsvCondition}
                    >
                      Upload stock file (.csv / .xlsx)
                    </Button>
                  </UploadFile>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  mr: 2,
                  my: 2,
                }}
              >
                <Typography
                  sx={{
                    color: stockExportCsvCondition ? Grey : Primary,
                    fontSize: "12px",
                  }}
                >
                  {isFetchingDataCsv
                    ? `กำลังดาวน์โหลดไฟล์...`
                    : `  หมายเหตุ: ระบบจะสามารถรับและส่งออกข้อมูลได้เมื่อมีการเลือก 'ร้านค้าเพียง 1 ร้านเท่านั้น'`}
                </Typography>
              </Box>
            </>
          )}

          <ProductMenuBar menuTab={tab} setMenuTab={setTab} />

          <CollapsibleTable
            ref={tableContainerRef}
            rows={productListData}
            columns={visibleColumns}
            collapsible={true}
            subTableColumns={visibleSubColumns}
            subTableDataField={subTableDataField}
            getToggleButtonText={(isOpen, count) =>
              isOpen
                ? `ดูตัวเลือกสินค้าน้อยลง`
                : `ดูตัวเลือกสินค้าจำนวน ${count} รายการ`
            }
            isAlwaysExpanded={tab === "stock" ? true : false}
            components={{
              NoRowsOverlay,
              // NoResultsOverlay,
            }}
            sortBy={dataSearch.sortBy}
            sortOrder={dataSearch.sortOrder}
            onSort={handleSort}
            isLoading={isLoading}
          />
          {/* <TablePagination
            component="div"
            count={rowCount}
            page={dataSearch.page}
            onPageChange={(e, newPage) => handlePageChange(newPage)}
            rowsPerPage={30}
            // onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          /> */}

          <Box
            display="flex"
            justifyContent="right"
            mt={2}
            sx={{ alignItems: "center" }}
          >
            <MuiTextField
              label=""
              type="text"
              size="small"
              onChange={handlePageInputChange}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: totalPages,
                  step: 1,
                },
              }}
              sx={{
                marginRight: "16px",
                width: 80,
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Pagination
              count={Math.ceil(rowCount / dataSearch.page_size)}
              page={dataSearch.page + 1}
              onChange={(e, newPage) => handlePageChange(newPage - 1)}
              sx={{
                "& .MuiPaginationItem-root": {
                  backgroundColor: "#F7CECB",
                  color: "#e04132",
                  "&.Mui-selected": {
                    backgroundColor: "#e04132",
                    color: "#F7CECB",
                  },
                  "&:hover": {
                    backgroundColor: "#e04132",
                    color: "#F7CECB",
                  },
                },
              }}
            />
          </Box>
        </DivMuiName>
      </Main>
    </>
  );
}

export default ProductList;
